import { GeekItem, CollapsibleItem } from '@/models';

export enum GCoinTransactionType {
  GrantedByAdmin = 'granted-by-admin',
  Withdraw = 'withdraw',
  CustomAward = 'custom-award',
  GrantedAutomatically = 'granted-automatically',
  Exchanged = 'exchanged',
}

export enum GCoinTransactionStatus {
  Pending = 'pending',
  Confirmed = 'confirmed',
  Ordered = 'ordered',
  Accepted = 'accepted',
  Rejected = 'rejected',
  Deleted = 'deleted',
}

export interface GCoinHistoryStatus {
  type: GCoinTransactionStatus;
  createdBy: GeekItem;
  createdAt: string;
  reason: string;
}

export interface GCoinGeekHistory extends CollapsibleItem {
  amount: number;
  createdAt: string;
  reason: string;
  type: GCoinTransactionType;
  status: GCoinHistoryStatus;
}
